export const calculateSubsegments = (parentLength, subsegmentLength) => {
  const subsegments = Math.ceil(parentLength / subsegmentLength);
  const subsegmentLengthActual = parentLength / subsegments;
  return { subsegments, subsegmentLengthActual };
};
